import React from 'react';
import type { Supplier } from '../../types/supplier';

interface SupplierCardProps {
  supplier: Supplier;
}

const SupplierCard: React.FC<SupplierCardProps> = ({ supplier }) => {
  return (
    <div className="bg-background-secondary rounded-lg border border-gray-800 overflow-hidden hover:border-brand/50 transition-all">
      <div className="p-6 flex flex-col md:flex-row gap-6">
        {/* Logo */}
        <div className="flex-shrink-0">
          <div className="bg-background p-4 rounded-lg w-32 h-32 border border-gray-800">
            <img
              src={supplier.logo_url}
              alt={supplier.company_name}
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex-grow">
          <h2 className="text-xl font-semibold text-content-primary mb-2">
            {supplier.company_name}
          </h2>
          <p className="text-content-secondary mb-4">
            {supplier.description}
          </p>

          {/* Categories */}
          <div className="flex flex-wrap gap-2 mb-4">
            {supplier.categories.map((category) => (
              <span
                key={category}
                className="px-2 py-1 text-sm rounded-full bg-background border border-gray-800 text-content-secondary"
              >
                {category.split('-').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </span>
            ))}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between">
            <span className="text-content-secondary">
              {supplier.location}
            </span>
            <a
              href={supplier.website_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors"
            >
              Visit Website →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierCard;